module.exports = __webpack_public_path__ + "img/banner4.c8a21852.jpg";